/* *
*
*  格式 yyyy-MM-dd hh:mm:ss
*
* */

import * as moment from 'moment'
export default (value, fmt) => {
  let date = moment(value).format(fmt)
  return date
}



// WEBPACK FOOTER //
// ./src/filters/format-time.js